import { Caption, Heading, IconInfo, LayoutHorizontal, LayoutSpaceVertical, LayoutVertical, Skeleton, Tooltip } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BLOCK_SIZE = '0.5rem';
export const MatchRateCard = ({
  children,
  count,
  isLoading = false,
  tooltip
}) => {
  return /*#__PURE__*/_jsxs(LayoutVertical, {
    alignItems: "stretch",
    border: "border",
    borderRadius: "border-radius",
    gap: "space-xxxs",
    justifyContent: "space-between",
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(LayoutHorizontal, {
      alignItems: "center",
      blockSize: "2.5rem",
      justifyContent: "center",
      padding: "space",
      paddingBlockEnd: "0",
      children: /*#__PURE__*/_jsx(Skeleton, {
        blockSize: BLOCK_SIZE,
        borderRadius: "border-radius-lg",
        inlineSize: "3.75rem",
        isLoading: isLoading,
        variant: "breeze",
        children: /*#__PURE__*/_jsx(Heading, {
          as: "h2",
          children: count
        })
      })
    }), /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: "space-sm",
      inlineSize: "100%",
      padding: "space",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        blockSize: BLOCK_SIZE,
        borderRadius: "border-radius-lg",
        inlineSize: "100%",
        isLoading: isLoading,
        variant: "breeze"
      }), /*#__PURE__*/_jsx(Skeleton, {
        blockSize: BLOCK_SIZE,
        borderRadius: "border-radius-lg",
        inlineSize: "100%",
        isLoading: isLoading,
        variant: "breeze",
        children: /*#__PURE__*/_jsx(Caption, {
          role: "label",
          children: children
        })
      })]
    }), /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      tooltip: tooltip,
      use: "longform",
      children: /*#__PURE__*/_jsx(LayoutHorizontal, {
        as: "footer",
        background: "background-color",
        blockSize: "2.5rem",
        borderBlockStart: "border",
        borderRadiusEndEnd: "border-radius",
        borderRadiusEndStart: "border-radius",
        justifyContent: "end",
        paddingBlock: "space-xxs",
        paddingInline: "space",
        children: tooltip ? /*#__PURE__*/_jsx(IconInfo, {}) : null
      })
    })]
  });
};